
import Input from "../Input";
import Output from "../Output";
import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import angol from "../../assets/angol.png"

import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"


function AngolMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Angol magyar fordító</title>
                <meta name='description' content="Angol magyar fordítás azonnal. Csak másold vagy írd be a lefordítandó szöveget, és nyomd meg a 'fordítás' gombot!" />
                <meta title="Angol-magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/angol-magyar-fordito" />
            </Helmet>
            <h1>Angol magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>Az angol nyelvről</h2>
                    <img src={angol} alt="angol zászló"></img>

                </div>

                
                <p>Az angol nyelv a világ egyik legelterjedtebb és legfontosabb nyelve. Több mint 1,5 milliárd ember beszéli anyanyelvként vagy második nyelvként. Az angol nyelv az Egyesült Királyságban keletkezett, majd az angol gyarmatosítás és az ipari forradalom következtében terjedt el a világ számos részén.</p>

                <p>Az angol a hivatalos nyelv számos országban, köztük az Egyesült Királyságban, az Egyesült Államokban, Kanadában, Ausztráliában és Új-Zélandon. Emellett nagy befolyással rendelkezik az üzleti és a tudományos világban, valamint a nemzetközi kommunikációban.</p>

                <p>Az angol nyelv négy fő nyelvi területre osztható: az angol brit változatára, az amerikai angolra, a kanadai angolra és az ausztrál angolra. Ezek között vannak kiejtésbeli, szókincsbeli és nyelvtani különbségek, bár az alapvető kommunikációhoz mind a négy változat használható.</p>

                <p>Szókincse nagyon gazdag, amely számos más nyelvből kölcsönzött szavakat tartalmaz. Az angolban megtalálható szókészlet lehetővé teszi a kifejező kommunikációt és a különböző témák lefedését.</p>

                <p>Nyelvtanjának rendszerét a következő alapvető elemei jellemzik: igék, főnevek, melléknevek, mellékhatározók, névelők, határozószók és kötőszók. Az angolban használnak továbbá időket, birtokviszonyokat, összetett mondatokat és egyéb nyelvi struktúrákat.</p>

                <p>Az angol nyelvet nemcsak az anyanyelvi beszélők tanulják, hanem világszerte sok ember kezdi el tanulni második nyelvként is. Az angol nyelvtudás előnyt jelenthet a munkaerőpiacon, az utazás során és a nemzetközi kapcsolatokban.</p>

                <p>Az nyelv gazdag irodalmi hagyománnyal is rendelkezik, és sok jelentős irodalmi művet hozott létre. William Shakespeare, Jane Austen, Charles Dickens és Virginia Woolf csak néhány neves angol író, akik hozzájárultak az angol irodalom fejlődéséhez.</p>


                <div className="sectionbottom">
                    <Link to="/magyar-angol-fordito">Magyar angol fordító</Link>

                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={arrow} alt=">"></img>                    
                    <img src={angol} alt="angol zászló"></img>
                </div>


            </section>


        </>

    )
}

export default AngolMagyar;

